document.addEventListener("DOMContentLoaded", () => {
  const claritySwatch = document.querySelector(
    '.swatch__wrapper.glass-clarity, .swatch__wrapper.media.variant-image.glass-clarity'
  );
  const isPrima = !!claritySwatch;
  const isDesktop = window.innerWidth > 768;


  const showDescriptions = () => {
    document.querySelectorAll(".variant-label__description").forEach(span => {
      // Remove hidden class to show description (text already split by Liquid)
      span.classList.remove("hidden");
    });
  };

  const showExplains = (hide = false) => {
    document.querySelectorAll(".variant-label__explain").forEach(span => {
      // Show/hide explain tooltips
      span.style.setProperty("display", hide ? "none" : "block", "important");
    });
  };

  const hoverText = document.querySelector(".text-hover");
  if (isPrima && hoverText) hoverText.className = "tooltip-text";

  if (isDesktop) {
    // Show descriptions on desktop
    const desInterval = setInterval(showDescriptions, 1000);
    setTimeout(() => clearInterval(desInterval), 5000);
    const exInterval = setInterval(() => showExplains(isPrima), 1000);
    setTimeout(() => clearInterval(exInterval), 5000);

    if (isPrima) {
      const hoverInterval = setInterval(() => {
        const swatches = document.querySelectorAll(".media-swatch");
        if (!swatches.length) return;
        swatches.forEach(container => {
          const desc = container.querySelector(".variant-label__description");
          const explain = container.querySelector(".variant-label__explain");
          const name = container.querySelector(".variant-label__name");
          if (!(desc && explain && name)) return;
          const originalDesc = desc.textContent;
          const tooltipText = explain.textContent;
          container.addEventListener("mouseenter", () => {
            if (tooltipText) {
              desc.textContent = tooltipText;
              name.style.display = "none";
            }
          });
          container.addEventListener("mouseleave", () => {
            desc.textContent = originalDesc;
            name.style.display = "block";
          });
        });
        clearInterval(hoverInterval);
      }, 1000);
      setTimeout(() => clearInterval(hoverInterval), 5000);
    } else {
      setInterval(() => {
        document.querySelectorAll(".media-swatch").forEach(container => {
          const desc = container.querySelector(".variant-label__description");
          const tooltip = container.querySelector(".variant-label__explain");
          if (!(desc && tooltip)) return;
          const rect = desc.getBoundingClientRect();
          tooltip.style.top = `${rect.top - tooltip.offsetHeight - 35}px`;
          tooltip.style.left = `${rect.left + rect.width / 2 - tooltip.offsetWidth / 2}px`;
        });
      }, 300);
    }
  }
});

// Template-agnostic host finder
function getMainProductHost() {
  return (
    document.querySelector(".shopify-section.shopify-section--main-product") ||
    document.querySelector(".shopify-section--product-template") ||
    document.querySelector('[data-section-type="main-product"]') ||
    document.body
  );
}

function modals() {
  const modal = document.getElementById("glass-clarity-modal");
  if (!modal) return;
  modal.style.display = "flex";
  const host = getMainProductHost();
  if (host && host.style) host.style.zIndex = "2147483201";
}

function closeModal() {
  const modal = document.getElementById("glass-clarity-modal");
  if (modal) modal.style.display = "none";
  const host = getMainProductHost();
  if (host && host.style) host.style.zIndex = "";
}

window.onclick = function (event) {
  const modal = document.getElementById("glass-clarity-modal");
  if (
    modal &&
    modal.style.display === "flex" &&
    event.target.classList &&
    event.target.classList.contains("modal-remain")
  ) {
    modal.style.display = "none";
    const host = getMainProductHost();
    if (host && host.style) host.style.zIndex = "";
  }
};
